var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "contents" },
    [
      _c("div", { staticClass: "opt" }, [
        _c(
          "div",
          { staticStyle: { display: "flex" } },
          [
            _c(
              "div",
              { staticClass: "search" },
              [
                _c(
                  "el-popover",
                  {
                    ref: "popover",
                    staticClass: "searchPop",
                    attrs: {
                      placement: "top",
                      title: "批量搜索",
                      trigger: "click",
                      width: "378",
                    },
                  },
                  [
                    _c(
                      "div",
                      {
                        staticClass: "close",
                        on: { click: _vm.closeSearchPanel },
                      },
                      [_c("i", { staticClass: "el-icon-close" })]
                    ),
                    _c("base-muti-input", {
                      ref: "baseMutiInput",
                      model: {
                        value: _vm.referenceNumber,
                        callback: function ($$v) {
                          _vm.referenceNumber = $$v
                        },
                        expression: "referenceNumber",
                      },
                    }),
                    _c(
                      "div",
                      {
                        staticStyle: {
                          "text-align": "right",
                          margin: "16px 0 0",
                        },
                      },
                      [
                        _c(
                          "el-button",
                          {
                            attrs: { size: "small" },
                            on: { click: _vm.handleEmpty },
                          },
                          [_vm._v("清空")]
                        ),
                        _c(
                          "div",
                          {
                            staticClass: "sure",
                            on: { mousedown: _vm.handleConfirm },
                          },
                          [_vm._v("确定")]
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c("el-input", {
                  staticClass: "input-search",
                  attrs: {
                    value: _vm.searchVal,
                    placeholder: "请输入中英文品名搜索",
                  },
                  on: { focus: _vm.handleFocus },
                }),
                _c(
                  "div",
                  {
                    staticClass: "btn-search",
                    on: { click: _vm.handleConfirm },
                  },
                  [_c("i", { staticClass: "el-icon-search" })]
                ),
              ],
              1
            ),
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.computedPermissions("新增"),
                    expression: "computedPermissions('新增')",
                  },
                ],
                staticClass: "add flex_c_c",
                attrs: { "v-permissson": _vm.computedPermissions("新增") },
                on: { click: _vm.add },
              },
              [
                _c("svg-icon", {
                  directives: [
                    {
                      name: "permissson",
                      rawName: "v-permissson",
                      value: "add",
                      expression: "'add'",
                    },
                  ],
                  attrs: { className: "icon", iconClass: "add" },
                }),
                _vm._v(" 新增 "),
              ],
              1
            ),
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.computedPermissions("导出"),
                    expression: "computedPermissions('导出')",
                  },
                ],
                staticClass: "add flex_c_c",
                attrs: { "v-permissson": _vm.computedPermissions("导出") },
                on: { click: _vm.downloadFile },
              },
              [
                _c("svg-icon", {
                  attrs: { className: "icon", iconClass: "download" },
                }),
                _vm._v(" 导出 "),
              ],
              1
            ),
            _c(
              "el-upload",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.computedPermissions("导入"),
                    expression: "computedPermissions('导入')",
                  },
                ],
                attrs: {
                  "v-permissson": _vm.computedPermissions("导入"),
                  action: "/api/basic/tax/importProductInfo",
                  headers: _vm.headers,
                  "file-list": _vm.fileList,
                  "show-file-list": false,
                  limit: 1,
                  "on-success": _vm.handleSuccess,
                  "on-error": _vm.handleError,
                },
              },
              [
                _c(
                  "div",
                  { staticClass: "add flex_c_c" },
                  [
                    _c("svg-icon", {
                      attrs: { className: "icon", iconClass: "upload" },
                    }),
                    _vm._v(" 导入 "),
                  ],
                  1
                ),
              ]
            ),
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.computedPermissions("下载模板"),
                    expression: "computedPermissions('下载模板')",
                  },
                ],
                staticClass: "add flex_c_c",
                attrs: { "v-permissson": _vm.computedPermissions("下载模板") },
                on: { click: _vm.download },
              },
              [
                _c("svg-icon", {
                  attrs: { className: "icon", iconClass: "download" },
                }),
                _vm._v(" 下载模板 "),
              ],
              1
            ),
          ],
          1
        ),
      ]),
      _c(
        "div",
        { staticClass: "data" },
        [
          _vm.height !== 0
            ? _c("BaseTable", {
                attrs: {
                  height: _vm.height,
                  tableData: _vm.tableData,
                  pageIndex: _vm.pager.pageIndex,
                  pageSize: _vm.pager.pageSize,
                  loading: _vm.loading,
                  isPager: true,
                  isEmptyBorder: true,
                },
                on: {
                  sortChange: _vm.sortChange,
                  handlePageChange: _vm.handlePageChange,
                },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "opt",
                      fn: function (row) {
                        return [
                          _c(
                            "el-popover",
                            {
                              ref: `popover${row.scope.id}`,
                              attrs: {
                                placement: "bottom-start",
                                "popper-class": "pop-table-opt",
                                width: "114",
                                trigger: "click",
                              },
                            },
                            [
                              _c("div", { staticClass: "table-opt" }, [
                                _c(
                                  "div",
                                  [
                                    _c(
                                      "el-button",
                                      {
                                        directives: [
                                          {
                                            name: "show",
                                            rawName: "v-show",
                                            value:
                                              _vm.computedPermissions("修改"),
                                            expression:
                                              "computedPermissions('修改')",
                                          },
                                        ],
                                        staticClass: "opt-item",
                                        attrs: {
                                          "v-permissson":
                                            _vm.computedPermissions("修改"),
                                        },
                                        on: {
                                          click: function ($event) {
                                            return _vm.handleEdit(row.scope)
                                          },
                                        },
                                      },
                                      [_vm._v("修改")]
                                    ),
                                    _c(
                                      "el-button",
                                      {
                                        directives: [
                                          {
                                            name: "show",
                                            rawName: "v-show",
                                            value:
                                              _vm.computedPermissions("删除"),
                                            expression:
                                              "computedPermissions('删除')",
                                          },
                                        ],
                                        staticClass: "opt-item",
                                        attrs: {
                                          "v-permissson":
                                            _vm.computedPermissions("删除"),
                                        },
                                        on: {
                                          click: function ($event) {
                                            return _vm.handleDelete(row.scope)
                                          },
                                        },
                                      },
                                      [_vm._v("删除")]
                                    ),
                                  ],
                                  1
                                ),
                              ]),
                              _c("img", {
                                attrs: {
                                  slot: "reference",
                                  src: require("@/assets/images/table/opt.png"),
                                },
                                slot: "reference",
                              }),
                            ]
                          ),
                        ]
                      },
                    },
                  ],
                  null,
                  false,
                  4253382280
                ),
              })
            : _vm._e(),
        ],
        1
      ),
      _c("ProductAddDialog", {
        attrs: { dialogVisible: _vm.dialogVisible, editData: _vm.editData },
        on: { cancel: _vm.cancel, ok: _vm.ok },
      }),
      _c("UpdateProductTagDialog", {
        attrs: { dialogVisible: _vm.dialogVisible1, editData: _vm.editData },
        on: { cancel: _vm.cancel, ok: _vm.ok },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }